const WORKY_BRAND_LOGO_SRC: string = '/worky-logo-full.png';

export { WORKY_BRAND_LOGO_SRC };
